import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import MainMenu from './components/MainMenu'
import VerticalTable from './components/VerticalTable'
import HorizontalTable from './components/HorizontalTable'
import { Container, Row, Col } from 'reactstrap';
import FetchRepos from './components/FetchRepos'
import Profile from './components/Profile'
import About from './components/About'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from 'react-router-dom';

function App() {
  const {
    isLoading,
    isAuthenticated,
    error,
    user,
    loginWithRedirect,
    logout,
  } = useAuth0();

  if (isLoading) {
    return <div>Loading....</div>;
  }
  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  if (isAuthenticated) {
    //FetchRepos();
    return (
      <Router>
      <div>
          <ul className="App-header">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/profile">Profile</Link>
              </li>
          </ul>
          <Routes>
              <Route exact path='/' element={<Container fluid><Row xs="6"><Col><Link to="/">Home</Link></Col><Col xs="4"><Link to="/about">About</Link></Col><Col xs="auto"><Link to="/profile">Profile</Link></Col></Row><Row><FetchRepos/></Row></Container>}></Route>
              <Route exact path='/about' element={< About />}></Route>
              <Route exact path='/profile' element={< Profile />}></Route>
          </Routes>
        Hello {user.name}. Root path is: {process.env.PUBLIC_URL}{' '}
        <button onClick={() => logout({ returnTo: process.env.REACT_APP_AUTH0_REDIRECT_URI })}>
          Log out
        </button>
      </div>
      </Router>
    );
  } else {
    return <button onClick={loginWithRedirect}>Log in</button>;
  }
}

export default App;